import apiClient from "./api.client.service";
import { InterviewSettingsDTO } from "../Dto/InterviewSettings.dto";
import { InterviewSettingsEntity } from "../Entities/InterviewSettings";

class InterviewSettingsService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getInterviewSettings(): Promise<InterviewSettingsEntity | null> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/settings/interview`
      );
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ InterviewSettingsService ~ getInterviewSettings ~ error:",
        error
      );
      return null;
    }
  }

  toUTC(date: Date) {
    return new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();
  }

  async updateInterviewSettings(
    interviewSettings: InterviewSettingsDTO,
    availableSlotsChanged: boolean,
    unavailableSlotsChanged: boolean
  ) {
    const updatedSettings = {
      ...interviewSettings,
      ...(availableSlotsChanged && {
        availableSlots: interviewSettings.availableSlots.map((slot) => ({
          ...slot,
          // fromTime: this.toUTC(slot.fromTime),
          // toTime: this.toUTC(slot.toTime),
          fromTime: slot.fromTime,
          toTime: slot.toTime,
        })),
      }),
      ...(unavailableSlotsChanged && {
        unavailableSlots: interviewSettings.unavailableSlots.map((slot) => ({
          ...slot,
          fromTime:
            // slot.fromTime instanceof Date && !isNaN(slot.fromTime.getTime())
            //   ? this.toUTC(slot.fromTime)
            //   : slot.fromTime,
            slot.fromTime,
          toTime:
            // slot.toTime instanceof Date && !isNaN(slot.toTime.getTime())
            //   ? this.toUTC(slot.toTime)
            //   : slot.toTime,
            slot.toTime
        })),
      }),
    };
    try {    
      console.log("🚀 ~ InterviewSettingsService ~ updatedSettings:", updatedSettings)  
      const response = await apiClient.patch(
        `${this.APIBaseUrl}/settings/interview`,
        updatedSettings,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ InterviewSettingsService ~ updateInterviewSettings ~ error:",
        error
      );
    }
  }
}

const interviewSettingsService = new InterviewSettingsService();
export default interviewSettingsService;
